import { render } from "./ChartsScreen.vue?vue&type=template&id=20ee0e20"
import script from "./ChartsScreen.vue?vue&type=script&lang=js"
export * from "./ChartsScreen.vue?vue&type=script&lang=js"

import "./ChartsScreen.vue?vue&type=style&index=0&id=20ee0e20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__